import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import { PropTypes } from 'prop-types';
import { SnackbarSettings } from 'redux/domain/Notification';

/**
 * Display components that can be displayed from anywhere in the app such as notifications.
 * @param {React} props
 */
const Global = ({ notification }) => (
	<div>
		<Snackbar {...notification} />
	</div>
);

Global.propTypes = {
	notification: PropTypes.instanceOf(SnackbarSettings).isRequired,
};
export default Global;
